import { render, staticRenderFns } from "./RoleSet.vue?vue&type=template&id=b436eba2&scoped=true"
import script from "./RoleSet.vue?vue&type=script&lang=js"
export * from "./RoleSet.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b436eba2",
  null
  
)

export default component.exports